// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"7163130b","160":"6fa896f0","226":"ad93aebb"}[chunkId] + ".chunk.js";
};